var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBookmarkFilled = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5 1.25A1.75 1.75 0 0 0 3.25 3v11a.75.75 0 0 0 1.28.53L8 11.06l3.47 3.47a.75.75 0 0 0 1.28-.53V3A1.75 1.75 0 0 0 11 1.25H5z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBookmarkFilled);
export default ForwardRef;